import {app_name, ncut_url} from './constants';

export default {
    computed:{
        appName(){
            return app_name;
        },
        ncutURL(){
            return ncut_url;
        }
    }
}